'use client'

import { useSyncExternalStore } from 'react'
import { useCookieValue } from '@/Cookies/useCookies'
import { BRAND_COOKIE, COUNTRY_COOKIE } from '@/lib/auth/marketCookies'
import {
  getBrandCodeForHost,
  type RegionalBrandCode,
} from '@/lib/seo/marketUrls'
import {
  resolveStorefrontMarket,
  type ResolveStorefrontMarketArgs,
} from '@/lib/storefront/resolveStorefrontMarket'

type UseStorefrontMarketArgs = Omit<
  ResolveStorefrontMarketArgs,
  'host' | 'hostBrand' | 'fallbackBrand' | 'cookieCountryIsoCode'
> & {
  fallbackBrand?: RegionalBrandCode | string | null
  cookieCountryIsoCode?: string | null
}

const parseRegionalBrandCode = (
  value: string | null | undefined
): RegionalBrandCode | null => {
  if (value === 'VANISHING_INC_UK' || value === 'VANISHING_INC_US') {
    return value
  }

  return null
}

const subscribeToHostChanges = () => () => {}

const getHostSnapshot = (): string | null => {
  if (typeof window === 'undefined') return null

  return window.location.host
}

const getServerHostSnapshot = () => null

export const useStorefrontMarket = (args: UseStorefrontMarketArgs = {}) => {
  const cookieBrand = parseRegionalBrandCode(useCookieValue(BRAND_COOKIE))
  const cookieCountryIsoCode = useCookieValue(COUNTRY_COOKIE)
  const host = useSyncExternalStore(
    subscribeToHostChanges,
    getHostSnapshot,
    getServerHostSnapshot
  )
  const hostBrand = host ? getBrandCodeForHost(host) : null

  return resolveStorefrontMarket({
    ...args,
    host,
    hostBrand,
    fallbackBrand: args.fallbackBrand ?? cookieBrand,
    cookieCountryIsoCode: args.cookieCountryIsoCode ?? cookieCountryIsoCode,
  })
}
